// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-cloud-widget__content[data-v-32e52f72]{display:flex;flex-wrap:wrap;gap:20px 30px;margin-top:16px;padding:30px;font-size:14px;font-weight:500;background-color:#edf2f4;border-radius:10px}.tag-cloud-widget__item[data-v-32e52f72],.tag-cloud-widget__item[data-v-32e52f72]:hover{color:var(--color-color-1)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
